import { service } from '@ember/service';

import $ from 'jquery';

import type { Service } from 'webapp-types';
import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export enum HiddenTourStep {
	BOARD_OPTIONS_HIDDEN = 1,
	LEFT_PANEL_HIDDEN = 2,
	RIGHT_PANEL_HIDDEN = 3,
	METRIC_SECTION_HIDDEN = 4,
	METRIC_HIDDEN = 5,
	VISUALIZATION_SECTION_HIDDEN = 6,
	VISUALIZATION_TYPE_SECTION_HIDDEN = 7,
}

export default class DesignerOptionHiddenTour extends TourBase {
	@service('flow/tour/designer') declare flowTourDesignerService: Service.Flow.Tour.Designer;

	get id(): string {
		return TourId.DESIGNER__BOARD_MORE_MENU;
	}

	override get stepData(): StepData[] {
		return [
			{
				step: HiddenTourStep.BOARD_OPTIONS_HIDDEN,
				direction: Direction.UP,
				allowStacked: true,
				attachTo: () => {
					return $('#boardSettings .pill-option-more');
				},
			},
			{
				step: HiddenTourStep.LEFT_PANEL_HIDDEN,
				direction: Direction.RIGHT,
				allowStacked: true,
				attachTo: () => {
					return $('.designer-panel--left .panel-toggler');
				},
			},
			{
				step: HiddenTourStep.RIGHT_PANEL_HIDDEN,
				direction: Direction.LEFT,
				allowStacked: true,
				attachTo: () => {
					return $('.designer-panel--right .panel-toggler');
				},
			},
			{
				step: HiddenTourStep.METRIC_SECTION_HIDDEN,
				direction: Direction.LEFT,
				allowStacked: true,
				attachTo: () => {
					return $('designer-panel--right .section--2 .icon');
				},
			},
			{
				step: HiddenTourStep.METRIC_HIDDEN,
				direction: Direction.UP,
				allowStacked: true,
				attachTo: () => {
					return $('.designer-panel--right .bs__metric__toggler');
				},
			},
			{
				step: HiddenTourStep.VISUALIZATION_SECTION_HIDDEN,
				direction: Direction.LEFT,
				allowStacked: true,
				attachTo: () => {
					return $('.designer-panel--right .section--1 .icon');
				},
			},
			{
				step: HiddenTourStep.VISUALIZATION_TYPE_SECTION_HIDDEN,
				direction: Direction.RIGHT,
				allowStacked: true,
				attachTo: () => {
					return $('.designer-panel--left .section--1 .icon');
				},
			},
		];
	}

	override onExplicitClose(): void {
		super.onExplicitClose();
		this.flowTourDesignerService.markHiddenTourAsExplicitlyClosed(this.currentStep);
	}
}
